export enum IType {
    user = 'user',
    attachment = 'attachment',
    password = 'password',
    file = 'file',
    tab = "tab",
    app = 'app',
    search = 'search',
    pagination = 'pagination',
    association = 'association',
    member = 'member',
    membership = 'membership',
    systemtable = 'systemtable',
    smr = 'smr',
    bms = 'bms',
    bmr = 'bmr',
    membershipRequest = 'membershipRequest',
    emailProvince = 'emailProvince',
    emailRegion = 'emailRegion'

  }